import React from "react";
import { PageHeader, EmptyState } from "@/design-system";

/**
 * Placeholder page for module routes registered in the AppShell router
 * but not yet implemented. Keeps the sidebar navigation honest: every
 * item resolves to a real route, no 404s.
 */
export default function ModulePlaceholder({ module }) {
  const label = module.charAt(0).toUpperCase() + module.slice(1);
  return (
    <div data-testid={`module-placeholder-${module}`}>
      <PageHeader
        eyebrow="Scheduled for later sprint"
        title={label}
        description={`The ${label} module ships in a subsequent sprint. The route is reserved so permission-aware navigation can be validated against the Sprint 10 foundation.`}
      />
      <EmptyState
        testid={`module-placeholder-empty-${module}`}
        title={`${label} UI not implemented yet.`}
        description="Backend endpoints are live — see /api/v1/openapi.json for the full contract."
      />
    </div>
  );
}
